import { NgModule } from '@angular/core'
import { LargeEventCardComponent } from './large-event-card.component'
import { CommonModule } from '@angular/common'
import { ThumbnailModule } from 'src/app/shared/thumbnails/thumbnail.module'
import { EventStatusModule } from '../events/components/event-status/event-status.module'
import { RouterModule } from '@angular/router'
import { TagsModule } from '../tags/tags.module'
import { FloPipeModule } from 'src/app/shared/pipes/flo-pipe.module'
import { AnalyticsModule } from '../../shared/analytics/analytics.module'
import { VideoPreviewModule } from '../video-preview/video-preview.module'
import { ElementIsVisibleModule } from '../element-is-visible/element-is-visible.module'
import { SvgModule } from '../../shared/svg/svg.module'

@NgModule({
  imports: [
    CommonModule,
    ThumbnailModule,
    RouterModule,
    TagsModule,
    EventStatusModule,
    FloPipeModule,
    SvgModule,
    AnalyticsModule,
    VideoPreviewModule,
    ElementIsVisibleModule
  ],
  exports: [LargeEventCardComponent],
  declarations: [LargeEventCardComponent]
})
export class LargeEventCardModule {}
